<template>
  <div style="background-color: #edf4fc;height: 100%;">
    <div style="height: 0.5rem;width: 100%;">
      <div style="margin-right: 0.1rem;float: right;width: 100%;">
        <a href="javascript:void(0)" @click="manager('/')" style="float: left;padding-left: 0.1rem;">
          <img src="@/assets/logo.gif" alt="联考之家" class="menu-img-size" />
        </a>
        <div class="header-home">
          <a href="javascript:void(0)" @click="manager('/login')" class="header-home-a">进入登录页</a>
        </div>
        <div class="header-home">
          <a href="javascript:void(0)" @click="manager('/')" class="header-home-a">回到首页</a>
        </div>
      </div>
    </div>
    <div class="register-form">
      <div class="register-form-div1">找回密码</div>
      <div class="register-form-div2">请填写用户基本信息</div>
      <el-form ref="form" :model="form" label-width="70px" :rules="rules">
        <el-form-item prop="userName" label="用户名">
          <el-input v-model="form.userName" placeholder="用户名" autofocus="true"></el-input>
        </el-form-item>
        <el-form-item prop="email" label="邮箱">
          <el-input v-model="form.email" placeholder="邮箱"></el-input>
        </el-form-item>
        <el-form-item prop="phonenumber" label="手机号">
          <el-input v-model="form.phonenumber" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="新密码">
          <el-input v-model="form.password" placeholder="新密码" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="passwordFind" class="register-form-button">找回密码</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { findPasswordAPI } from '@/api/user'

export default {
  // name 是当前组件的名称（建议为每个组件都指定唯一的 name 名称）
  name: 'FindPassword',
  data () {
    return {
      // 登录表单的数据，最终要双向绑定到 form 这个数据对象上
      form: {
        // 用户名
        userName: '',
        // 邮箱
        email: '',
        password: '',
        // 手机号
        phonenumber: ''
      },
      // 表单的校验规则对象
      rules: {
        // 用户名的校验规则
        userName: [{ required: true, message: '请填写您的用户名', trigger: 'blur' }],
        // 邮箱的校验规则
        email: [{ required: true, message: '请填写您的邮箱', trigger: 'blur' }],
        // 密码的校验规则
        password: [{ required: true, message: '请填写您的密码', trigger: 'blur' }],
        // 手机号的校验规则
        // 只有同时满足以下两个验证规则，才能验证通过
        phonenumber: [
          // 必填项的校验规则
          { required: true, message: '请填写您的手机号', trigger: 'blur' },
          // 11 位手机号的校验规则
          { pattern: /^1\d{10}$/, message: '请填写正确的手机号', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async passwordFind () {
      if (this.form.userName !== '' && this.form.email !== '' && this.form.phonenumber !== '' && this.form.password !== '') {
        const { data: res } = await findPasswordAPI(this.form)
        // 判断是否登录成功了
        if (res.code === 200) {
          // 注册成功后，跳转到登录页
          this.$router.push('/login')
        } else if (res.code === 404) {
          this.$message({
            message: '您无权修改',
            type: 'warning'
          })
        } else {
          this.$message({
            message: '此用户名已经使用',
            type: 'warning'
          })
        }
      } else {
        this.$message({
          message: '用户名、邮箱、手机号和密码必须全部填写',
          type: 'warning'
        })
      }
    },
    managerBlank (address) {
      const routeData = this.$router.resolve({ path: address })
      window.open(routeData.href, '_blank')
    },
    manager (address) {
      this.$router.push({ path: address })
    }
  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none !important;
}
a:hover {
  color: red !important;
}
.menu-img-size {
  width: 1rem;
  height: 0.5rem;
}
.header-home {
  float: right;
  margin-right: 0.1rem !important;
  height: 0.5rem;
  font-size: 0.13rem;
  padding-right: 0.2rem;
}
.header-home-a {
  display: inline-block;
  height: 0.5rem;
  line-height: 0.5rem;
  vertical-align: middle;
  text-align: center;
}
.register-form {
  right: 1rem;
  width: 5rem;
  margin: 0 auto;
  padding-top: 0.2rem;
  margin-left: 2.4rem;
  padding-bottom: 0.2rem;
}
.register-form-div1 {
  display: inline-block;
  height: 0.4rem;
  width: 5rem;
  vertical-align: middle;
  text-align: center;
  font-size: 0.3rem;
  margin-bottom: 0.1rem;
}
.register-form-div2 {
  display: inline-block;
  height: 0.2rem;
  width: 5rem;
  vertical-align: middle;
  text-align: center;
  font-size: 0.13rem;
  color:gray;
  margin-bottom: 0.2rem;
}
.register-form-button {
  width: 100%;
  margin: 0 auto;
  font-size: 0.13rem;
}
.el-form-item {
  margin-bottom: 0.2rem;
}
/deep/ .el-input__inner {
  font-size: 0.13rem;
}
/deep/ .el-form-item__label {
  font-size: 0.13rem;
}
</style>
